import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../uiModels/parameterOperations/types'
import type { useTimelineScale } from '../versionedTimeline/useTimelineScale'
import { MultipleParameterDefinitionVersionsCircle } from './MultipleParameterDefinitionVersionsCircle'
import { SingleParameterDefinitionVersionCircle } from './SingleParameterDefinitionVersionCircle'

type Props = {
  versions: IndexedParameterDefinitionCreateOperationWithMetaData[]
  dateToPixel: ReturnType<typeof useTimelineScale>['dateToPixel']
  earliestVersionDate: Date
}

export const ParameterVersionCircle = ({
  earliestVersionDate,
  versions,
  dateToPixel,
}: Props) =>
  versions.length > 1 ? (
    <MultipleParameterDefinitionVersionsCircle
      dateToPixel={dateToPixel}
      earliestVersionDate={earliestVersionDate}
      versions={versions}
    />
  ) : (
    <SingleParameterDefinitionVersionCircle
      dateToPixel={dateToPixel}
      earliestVersionDate={earliestVersionDate}
      version={versions[0]}
    />
  )
